import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'

import buildAntdTheme from './components/kit/vendors/antd/themes'
import english from './locales/en-US'
import portuguese from './locales/pt-BR'

const locales = {
  'en-US': english,
  'pt-BR': portuguese,
}

const mapStateToProps = ({ settings }) => ({ settings })

function Localization({ children, settings: { locale, theme, primaryColor } }) {
  const currentLocale = locales[locale]
  return (
    <ConfigProvider
      locale={currentLocale.localeAntd}
      theme={buildAntdTheme({ theme, primaryColor })}
    >
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}

export default connect(mapStateToProps)(Localization)
